var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-view"},[_c('div',{staticClass:"container-scroller"},[_c('Header'),_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"content-wrapper background"},[_c('router-view')],1),_c('Footer')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }